import { render } from "./register-attribute-item.vue?vue&type=template&id=c2f6862e"
import script from "./register-attribute-item.vue?vue&type=script&lang=js"
export * from "./register-attribute-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__